import { PosTerminalStatement, Statement, StatementBrief } from './type';
import { formatDateView } from '@/shared/lib/date';
import {
  Language,
  PosTerminalStatementFragment,
  StatementFragment,
  StatementOrder,
  StatementStatus,
} from '@/app/graphql/statement/sdk.statement';
import { date } from 'quasar';

export function generateStatementStatusLabel(fileStatus: StatementStatus) {
  if (!fileStatus) return fileStatus;

  switch (fileStatus) {
    case StatementStatus.Pending:
      return {
        label: 'DOCUMENTS.STATEMENT_ACCOUNT.STATUS.PENDING',
        classList: 'status-warning',
      };
    case StatementStatus.InProgress:
      return {
        label: 'DOCUMENTS.STATEMENT_ACCOUNT.STATUS.IN_PROGRESS',
        classList: 'status-warning',
      };
    case StatementStatus.Ready:
      return {
        label: 'DOCUMENTS.STATEMENT_ACCOUNT.STATUS.READY',
        classList: 'status-success',
      };
    case StatementStatus.NotFound:
      return {
        label: 'DOCUMENTS.STATEMENT_ACCOUNT.STATUS.NOT_FOUND',
        classList: 'status-muted',
      };
    case StatementStatus.Fail:
      return {
        label: 'DOCUMENTS.STATEMENT_ACCOUNT.STATUS.FAIL',
        classList: 'status-danger',
      };
  }
}

export function formatPosStatements(statements: PosTerminalStatementFragment[]): PosTerminalStatement[] {
  return statements.map((statement) => formatPosStatement(statement));
}

export function formatStatements(statements: StatementFragment[]): Statement[] {
  return statements.map((statement) => formatStatement(statement));
}

export function formatPosStatement(statement: PosTerminalStatementFragment): PosTerminalStatement {
  return {
    ...statement,
    partyId: statement.partyID,
    statusLabel: generateStatementStatusLabel(statement.status),
    endDate: formatDateView(statement.endDate),
    startDate: formatDateView(statement.startDate),
    requestDate: date.formatDate(statement.requestDate, 'DD.MM.YYYY HH:mm:ss'),
  };
}

export function formatStatement(statement: StatementFragment): Statement {
  return {
    ...statement,
    statusLabel: generateStatementStatusLabel(statement.status),
    endDate: formatDateView(statement.endDate),
    startDate: formatDateView(statement.startDate),
    requestDate: date.formatDate(statement.requestDate, 'DD.MM.YYYY HH:mm'),
  };
}

export function formatListenStatement(statement: StatementBrief): StatementBrief {
  return {
    ...statement,
    statusLabel: generateStatementStatusLabel(statement.status),
  };
}

export function isStatementOrderInputType(something: StatementOrder | {}): something is StatementOrder {
  return !!Object.keys(something as StatementOrder).length;
}

export function getStatementLang(locale: string) {
  switch (locale) {
    case 'ENG':
      return Language.En;
    case 'KG':
      return Language.Kg;
    case 'RU':
    default:
      return Language.Ru;
  }
}
